"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _conditionalTextBlock = _interopRequireDefault(require("./conditional-text-block"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var isOnCurrentSite = function isOnCurrentSite(entry) {
  var _entry$site;
  return (_entry$site = entry.site) === null || _entry$site === void 0 ? void 0 : _entry$site.includes(process.env.NEXT_PUBLIC_SITE);
};
var createResultCard = function createResultCard(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    name: (0, _utils.getProp)(fields, 'name'),
    type: (0, _utils.getProp)(fields, 'type'),
    summarySections: (0, _utils.getProp)(fields, 'summarySections', []).map(_conditionalTextBlock["default"]).filter(isOnCurrentSite),
    whatNextSections: (0, _utils.getProp)(fields, 'whatNextSections', []).map(_conditionalTextBlock["default"]).filter(isOnCurrentSite)
  };
};
var _default = createResultCard;
exports["default"] = _default;